import { EmissionsHomeViewFilterArea } from "#src/batteries-included-components/FilterAreas/DashboardsFilterAreas/DashboardsFilterAreas";
import { IsFeatureAvailable } from "#src/batteries-included-components/Layouts/Authorization/IsFeatureAvailable";
import { useAuthenticatedContext } from "#src/contexts/AuthenticatedContext.helpers";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { HomeRoute } from "#src/routes/home";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { generateDocumentTitle, Page } from "@validereinc/common-components";
import classNames from "classnames/bind";
import React from "react";
import { Titled } from "react-titled";
import { CalculatorResultsAccessDeniedPanel } from "./CalculatorResultsAccessDeniedPanel";
import { EmissionsHomeMapPanel } from "./EmissionsHomeMapPanel";
import { FacilityEmissionsByPollutantDataTablePanel } from "./FacilityEmissionsByPollutantDataTablePanel";
import { PollutantPieChartPanel } from "./PollutantPieChartPanel";
import { TotalEmissionsPanel } from "./TotalEmissionsPanel";
import styles from "./emission-home.module.scss";

const cx = classNames.bind(styles);

export const EmissionsHomePage = () => {
  const [viewConfigStorageKey, tableStateStorageKey] = useStorageKey(
    ["view-configuration", "table-state"],
    ["home", "emissions"]
  );
  const {
    v2: {
      userInfo: { user },
      companyInfo: { company },
    },
  } = useAuthenticatedContext();

  const [breadcrumbs] = useBreadcrumbsFromRoute(HomeRoute);
  const homePageTitle = user?.name
    ? `Welcome, ${user?.name.split(" ")[0]}`
    : "Welcome";

  return (
    <Titled title={generateDocumentTitle(HomeRoute.title)}>
      <Page
        title={homePageTitle}
        breadcrumbs={breadcrumbs}
        category={company?.name ?? ""}
      >
        <EmissionsHomeViewFilterArea
          viewConfigStorageKey={viewConfigStorageKey}
        />
        <div
          className={cx("grid")}
          style={{ marginTop: 16 }}
        >
          <EmissionsHomeMapPanel viewConfigStorageKey={viewConfigStorageKey} />
          <IsFeatureAvailable
            featureFlagQuery="core:home"
            permissionQuery={{
              $and: ["facilities:read", "calculator_results:read"],
            }}
            fallbackChildren={
              <CalculatorResultsAccessDeniedPanel title="Total Emissions" />
            }
          >
            <TotalEmissionsPanel viewConfigStorageKey={viewConfigStorageKey} />
          </IsFeatureAvailable>
          <IsFeatureAvailable
            featureFlagQuery="core:home"
            permissionQuery={{
              $and: ["facilities:read", "calculator_results:read"],
            }}
            fallbackChildren={
              <CalculatorResultsAccessDeniedPanel title="Emissions Split by CO2e" />
            }
          >
            <PollutantPieChartPanel
              viewConfigStorageKey={viewConfigStorageKey}
            />
          </IsFeatureAvailable>
          <IsFeatureAvailable
            featureFlagQuery="core:home"
            permissionQuery={{
              $and: ["facilities:read", "calculator_results:read"],
            }}
            fallbackChildren={
              <CalculatorResultsAccessDeniedPanel title="Emissions by Facility" />
            }
          >
            <FacilityEmissionsByPollutantDataTablePanel
              viewConfigStorageKey={viewConfigStorageKey}
              tableStateStorageKey={tableStateStorageKey}
            />
          </IsFeatureAvailable>
        </div>
      </Page>
    </Titled>
  );
};
